/**
 * 関数
 */
function ClickGoTop() {
  const duration = 300;
  let begin = new Date() - 0;
  let yOffset = window.pageYOffset;
  let timer = setInterval(() => {
    let current = new Date() - begin;
    if (current > duration) {
      clearInterval(timer);
      current = duration;
    }
    window.scrollTo(0, yOffset * (1 - current / duration));
  }, 10);
}

function ClickToggle(th) {
  th.classList.toggle("js-open");
}

function ClickTab(data_tab, th) {
  const parent = th.parentNode;
  const el = parent.children;
  const el_data = parent.dataset.tab;
  for (let i = 0; i < el.length; i++) {
    el[i].classList.remove("js-open");
  }
  th.classList.add("js-open");

  for (let i = 0; i < el.length; i++) {
    if (el[i].classList.contains("js-open")) {
      var index = i;
    }
  }
  const tab_contents = document.querySelectorAll("[data-tab_contents]");
  for (let i = 0, len = tab_contents.length; i < len; ++i) {
    const tab_data = tab_contents[i].dataset.tab_contents;
    if (el_data == tab_data) {
      let tab_child = tab_contents[i].children;
      for (var ii = 0; ii < tab_child.length; ii++) {
        tab_child[ii].classList.remove("js-open");
      }
      tab_child[index].classList.add("js-open");
    }
  }
}

function ClickModal(data_modal, th) {
  th.classList.toggle("js-open");
  const this_data = th.dataset.modal;
  const modal_contents = document.querySelectorAll("[data-modal_contents]");
  for (let i = 0, len = modal_contents.length; i < len; ++i) {
    const modal_contents_data = modal_contents[i].dataset.modal_contents;
    if (this_data == modal_contents_data) {
      if (th.classList.contains("js-open")) {
        modal_contents[i].classList.add("js-open");
        document.body.classList.add("js-moda-body");
      } else {
        modal_contents[i].classList.remove("js-open");
      }
    }
  }
  const modal_close = document.querySelectorAll("[data-modal_close]");
  for (let i = 0, len = modal_close.length; i < len; ++i) {
    const modal_close_data = modal_close[i].dataset.modal_close;
    modal_close[i].addEventListener("click", e => {
      if (this_data == modal_close_data) {
        th.classList.remove("js-open");
        modal_contents[i].classList.remove("js-open");
        document.body.classList.remove("js-moda-body");
      }
    });
  }
}

function SmoothLink() {
  const interval = 10;
  const divisor = 8;
  const range = divisor / 2 + 1;

  const urlHash = location.hash;
  if (urlHash) {
    // window.scrollTo(0, 0);
    // const element = document.getElementById("header-bar_area");
    // let headH = ElementHeight(element);
    // if (headH < 60 || headH === undefined) {
    //   headH = 60;
    // } else {
    //   headH = headH + 10;
    // }
    // let toY;
    // let nowY = window.pageYOffset;
    // const target = document.querySelector(urlHash);
    // const targetRect = target.getBoundingClientRect();
    // const targetY = targetRect.top + nowY - headH;
    // setTimeout(function doScroll2(){
    //   toY = nowY + Math.round((targetY - nowY) / divisor);
    //   window.scrollTo(0, toY);
    //   nowY = toY;
    //   if (document.body.clientHeight - window.innerHeight < toY) {
    //     window.scrollTo(0, document.body.clientHeight);
    //     return;
    //   }
    //   if (toY >= targetY + range || toY <= targetY - range) {
    //     window.setTimeout(doScroll2, interval);
    //   } else {
    //     window.scrollTo(0, targetY);
    //   }
    // }, 200);
  } else {
    const links = document.querySelectorAll('a[href^="#"]');
    for (let i = 0; i < links.length; i++) {
      links[i].addEventListener("click", e => {
        e.preventDefault();
        const element = document.getElementById("header-bar_area");
        let headH = ElementHeight(element);
        if (headH < 60 || headH === undefined) {
          headH = 60;
        } else {
          headH = headH + 10;
        }
        let toY;
        let nowY = window.pageYOffset;
        const href = e.target.getAttribute("href");
        const target = document.querySelector(href);
        const targetRect = target.getBoundingClientRect();
        const targetY = targetRect.top + nowY - headH;

        (function doScroll() {
          toY = nowY + Math.round((targetY - nowY) / divisor);
          window.scrollTo(0, toY);
          nowY = toY;

          if (document.body.clientHeight - window.innerHeight < toY) {
            window.scrollTo(0, document.body.clientHeight);
            return;
          }
          if (toY >= targetY + range || toY <= targetY - range) {
            window.setTimeout(doScroll, interval);
          } else {
            window.scrollTo(0, targetY);
          }
        })();
      });
    }
  }
}

// function ScrollContents() {
//   const data_click = document.querySelectorAll('[data-events="jamp_btn"] a');
//   for (let i = 0, len = data_click.length; i < len; ++i) {
//     data_click[i].addEventListener("click", (e) => {
//         e.preventDefault();
//         var target, targetP, position;
//         target = $(this).attr("href");
//         targetP = $(target).position();
//         scrollH = $('[data-events="jamp_area"]').scrollTop();
//         position = targetP.top + scrollH;
//         $('[data-events="jamp_area"]').animate(
//           {
//             scrollTop: position
//           },
//           400
//         );
//       },
//       false
//     );
//   }
// }
function ClickMenu() {
  const toggleBtn = document.getElementById("menu_button");
  const navView = document.getElementById("menu_area");
  if (toggleBtn.getAttribute("aria-expanded") == "false" ) {
    document.body.classList.add("js-munu_open-body");
    toggleBtn.setAttribute("aria-expanded", "true");
    navView.setAttribute("aria-expanded", "true");
    navView.classList.add('js-open');
    navView.classList.remove('js-close');
  } else {
    document.body.classList.remove("js-munu_open-body");
    toggleBtn.setAttribute("aria-expanded", "false");
    navView.setAttribute("aria-expanded", "false");
    navView.classList.remove('js-open');
    navView.classList.add('js-close');
  }
}

function PagerFetch(e) {
  const ajaxurl =
      window.location.protocol +
      "//" +
      window.location.host +
      "/wp-admin/admin-ajax.php",
    url = e.getAttribute("href"),
    fetch_catid = document.querySelector("[data-pager_fetch_catid"),
    fetch_template = document.querySelector("[data-pager_fetch_template"),
    result = url.split("/").filter(e => Boolean(e));
  let paged = null;
  if (isFinite(result[result.length - 1])) {
    paged = result[result.length - 1];
  } else {
    paged = 1;
  }
  if (self.fetch) {
    const params = new URLSearchParams();
    const articleOuter = document.querySelector('[data-receive="pager_fetch"]');
    params.append("paged", paged);
    params.append("action", "pager_fetch");
    params.append("catid", fetch_catid.dataset.pager_fetch_catid);
    params.append("template", fetch_template.dataset.pager_fetch_template);
    const first_text = articleOuter.innerHTML;
    window.history.replaceState(first_text, null, url);
    fetch(ajaxurl, {
      method: "POST",
      credentials: "same-origin",
      body: params
    })
      .then(response => {
        return response.text();
      })
      .then(
        text => {
          articleOuter.textContent = "";
          articleOuter.insertAdjacentHTML("afterbegin", text);
          ClickPager("[data-pager]");
          DataSrc("[data-src]");
          DataScroll("[data-scroll]");
          window.location.hash = "content";
          window.history.replaceState(text, null, url);
        },
        error => {
          console.log(error);
        }
      );
  } else {
    alert(
      "ご使用のブラウザはサポートしていません。Chrome, firefox, Edge等の最新版のブラウザをご使用下さい"
    );
  }
  return false;
}

function ClickPager(data) {
  const data_click = document.querySelectorAll(data + " a");
  for (let i = 0, len = data_click.length; i < len; ++i) {
    data_click[i].addEventListener(
      "click",
      e => {
        e.preventDefault();
        PagerFetch(data_click[i]);
      },
      false
    );
  }
}

function DataElementHide(data) {
  const targets = Array.from(document.querySelectorAll(data));
  const options = {
    rootMaring: "0 0",
    threshold: [0.02, 0.5, 0.08]
  };
  const observer = new IntersectionObserver(function DataElementHide(
    entries,
    object
  ) {
    entries.forEach(entry => {
      const div = entry.target;
      const data_val = div.dataset.element_hide;
      if (entry.intersectionRatio < 0.02) {
        if (!div.classList.contains(data_val)) {
          div.classList.add(data_val);
          div.classList.remove(data_val + "-del");
          document.body.classList.add(data_val + "-body");
          document.body.classList.remove(data_val + "-del-body");
        }
      } else if (entry.intersectionRatio >= 0.02) {
        //要素外
        if (div.classList.contains(data_val)) {
          div.classList.remove(data_val);
          div.classList.add(data_val + "-del");
          document.body.classList.remove(data_val + "-body");
          document.body.classList.add(data_val + "-del-body");
        }
      }
    });
  },
  options);
  targets.forEach(div => {
    observer.observe(div);
  });
}

function DataScroll(data) {
  const targets = Array.from(document.querySelectorAll(data));
  const options = {
    rootMaring: "0 0",
    threshold: [0, 0.3, 0.7, 1.0]
  };
  const observer = new IntersectionObserver(function DataScroll(
    entries,
    object
  ) {
    entries.forEach(entry => {
      const div = entry.target;
      const data_val = div.dataset.scroll;
      if (entry.isIntersecting && entry.intersectionRatio > 0.3) {
        div.classList.add("js-active");
        div.classList.add(data_val);
        const anime_loop_flag_val = document.body.dataset.anime_loop_flag;
        if (anime_loop_flag_val == false) {
          object.unobserve(div);
        }
      } else if (!entry.isIntersecting && entry.intersectionRatio == 0) {
        if (div.classList.contains(data_val)) {
          div.classList.remove("js-active");
          div.classList.remove(data_val);
        }
      }
    });
  },
  options);
  targets.forEach(div => {
    observer.observe(div);
  });
}

function DataSrc(data) {
  const targets = Array.from(document.querySelectorAll(data));
  const options = {
    rootMaring: "300px 0",
    threshold: [0, 0.1, 0.3, 0.6, 0.9, 1.0]
  };
  const observer = new IntersectionObserver(function DataSrc(entries, object) {
    entries.forEach(entry => {
      const img = entry.target;
      const img_path = "data-src";
      const src_val = img.getAttribute(img_path);
      if (src_val && entry.intersectionRatio > 0) {
        img.src = src_val;
        img.removeAttribute(img_path);
        img.classList.add("js-src_active");
        img.parentNode.classList.add("js-src_active_parent");
        img.parentNode.parentNode.classList.add("js-src_active_root");
        //videoタグで効かない
        // img.onload = function () {
        //     this.removeAttribute(img_path);
        //     this.classList.add('js-src_active');
        //     this.parentNode.classList.add('js-src_active_parent');
        //     this.parentNode.parentNode.classList.add('js-src_active_root');
        // };
        object.unobserve(img);
      }
    });
  }, options);
  targets.forEach(img => {
    observer.observe(img);
  });
}

function TextSpanDelay(data) {
  var textbox = document.querySelectorAll(data);
  for (let i = 0, len = textbox.length; i < len; ++i) {
    const text = textbox[i].textContent;
    const val = textbox[i].dataset.span_delay;
    textbox[i].innerHTML = '';
    text.split("").forEach((c, index) => {
      textbox[i].innerHTML +=
        '<span style="animation-delay:' + index * val + 's">' + c + "</span>";
    });
  }
}

function ElementHeight(element) {
  var h = element.outerHeight;
  return h;
}
/**
 * 実行
 */
import quicklink from "quicklink/dist/quicklink.mjs";
require('intersection-observer');
// import Swiper from "swiper";
(function() {
  "use strict";

  document.body.classList.add("js-validity");

  const quicklink_flag_val = document.body.dataset.quicklink_flag;
  if (quicklink_flag_val == true) {
    quicklink({
      ignores: [
        /\/wp-admin\/?/,
        /\/wp-login\/?/,
        /\/contact\/?/,
        uri => uri.includes("#"),
        (uri, elem) => elem.hasAttribute("noprefetch")
        // or RegExp: /#(.+)/
        // or element matching: (uri, elem) => !!elem.hash
      ]
    });
  }
  DataElementHide("[data-element_hide]");
  DataScroll("[data-scroll]");
  DataSrc("[data-src]");
  TextSpanDelay("[data-span_delay]");
  SmoothLink();
  if (quicklink_flag_val == false) {
    ClickPager("[data-pager]");
  }
  // ScrollContents();
  window.onpopstate = e => {
    const state = e.state;
    if (state) {
      const articleOuter = document.querySelector(
        '[data-receive="pager_fetch"]'
      );
      articleOuter.textContent = "";
      articleOuter.insertAdjacentHTML("afterbegin", state);
      const archive_page = document.querySelector("[data-archive_page]");
      const paged = archive_page.dataset.archive_page;
      history.replaceState(state, null, paged);
      ClickPager("[data-pager]");
      DataSrc("[data-src]");
      DataScroll("[data-scroll]");
    }
  };

  const data_click = document.querySelectorAll("[data-click]");
  for (let i = 0, len = data_click.length; i < len; ++i) {
    data_click[i].addEventListener("click", e => {
      const click = data_click[i].dataset.click;
      switch (click) {
        case "menu":
          ClickMenu();
          break;
        case "toggle":
          ClickToggle(data_click[i]);
          break;
        case "go_top":
          ClickGoTop();
          break;
      }
    });
  }

  const data_tab = document.querySelectorAll("[data-tab] > li");
  for (let i = 0, len = data_tab.length; i < len; ++i) {
    data_tab[i].addEventListener("click", e => {
      ClickTab(data_tab, data_tab[i]);
    });
  }

  const data_modal = document.querySelectorAll("[data-modal]");
  for (let i = 0, len = data_modal.length; i < len; ++i) {
    data_modal[i].addEventListener("click", e => {
      ClickModal(data_modal, data_modal[i]);
    });
  }

})();
